// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3l311","left":"InfoRow_left__A9nnn"};